import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string | number;
}

const TextTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="footerMainText" entityId={Number(entityId)} />;
};

export default TextTrailTab;
